export default __webpack_public_path__ + "static/media/GPA_CommunityPowered.eb688aba.png";